import { TakeOverTypeEnum } from '@outbound-ai/softphone'
import { useAppDispatch, useAppSelector } from 'appState/store'
import { apiPaths } from 'configs/apiConfigs'
import { useCurrentUserCalls } from 'features/calls/callsHooks'
import { callsSliceLiveCallInitialState, updateLiveCall } from 'features/calls/callsSlice'
import { AutomationTypeEnum, CallTypeEnum, CallTypeToJobTypeEnum, ICall } from 'features/calls/types'
import { getClaimCallPath } from 'features/claims/utils/claimsPathUtils'
import { differenceBy } from 'lodash'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getTntIdForNavigation } from 'utils/tenantUrlUtils'
import { useSWRConfig } from 'swr'
import { dotNetInteger32 } from 'utils'
import { notificator } from 'utils/notificator/notificator'

const CallCompletionNotifier = () => {
  // global state
  const { user } = useAppSelector((state) => state.auth)

  const { takeOver, lastCallJobIdUserCompleted, automationType, shouldRedirectIfCallTakenOver } = useAppSelector(
    (state) => state.calls?.talkToPayorRepLiveCall,
  )
  // api
  const { data: currentUserCallsResponse } = useCurrentUserCalls(user?.id)

  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const location = useLocation()

  const { mutate } = useSWRConfig()
  const [activeCalls, setActiveCalls] = useState<ICall[]>([])

  /*const generateNotificationContent = (claimId: string, callId: string): JSX.Element => {
    return (
      <section>
        <p>
          <Link to={paths.claimsCallSummary(claimId, callId)}>
            One of the active calls has finished. Click here for more information.{' '}
          </Link>
        </p>
      </section>
    )
  }*/
  useEffect(() => {
    if (currentUserCallsResponse?.data) {
      if (currentUserCallsResponse?.data.length < activeCalls.length) {
        const completedCalls = differenceBy(activeCalls, currentUserCallsResponse?.data, 'jobId')
        setActiveCalls(currentUserCallsResponse?.data)
        completedCalls.forEach((call) => {
          if (!location.pathname.includes(call.jobId) && call.jobId !== lastCallJobIdUserCompleted) {
            if (
              [
                CallTypeToJobTypeEnum.attendable,
                CallTypeToJobTypeEnum.humanAgent,
                CallTypeToJobTypeEnum.standard,
              ].includes(call.jobType!)
            ) {
              dispatch(updateLiveCall(callsSliceLiveCallInitialState))
            }
            // Updates the claimCalls because it stay with Call in progress

            mutate(apiPaths.claimCalls(call.oaiClaimId, `?Limit=${dotNetInteger32}`))
            //dispatch(refreshClaimCount({ refreshCount: true }))
            // notificator.info(generateNotificationContent(call.oaiClaimId, call.jobId), { autoClose: 10000 })
            //notificator.info(generateNotificationContent(call.oaiClaimId, call.jobId), { autoClose: 10000 })
            const CompletedCalls = JSON.parse(localStorage.getItem('completedcalls')!) || []
            CompletedCalls.push(call.jobId)
            localStorage.setItem('completedcalls', JSON.stringify(CompletedCalls))
          }
        })
      } else if (currentUserCallsResponse?.data.length > activeCalls.length) {
        setActiveCalls(currentUserCallsResponse?.data)
      }
    }
  }, [currentUserCallsResponse?.data])

  const calls = currentUserCallsResponse?.data
  const activeTalkToPayorRepCall = calls?.find((call) =>
    [
      CallTypeToJobTypeEnum.attendable,
      CallTypeToJobTypeEnum.humanAgent,
      CallTypeToJobTypeEnum.standard,
      CallTypeToJobTypeEnum.diagnosticHeadset,
    ].includes(call?.jobType as CallTypeToJobTypeEnum),
  )

  const redirectToLiveCalls = (oaiClaimId: string, jobId: string) => {
    const tenantId = getTntIdForNavigation()
    navigate(getClaimCallPath(tenantId, oaiClaimId, jobId))
  }

  // effects
  useEffect(() => {
    if (activeTalkToPayorRepCall) {
      if (notificator.isDesktopNotificationsNotSelected()) notificator.getDesktopNotificationPermission()
      const { jobId, oaiClaimId, claimId, jbId } = activeTalkToPayorRepCall
      dispatch(
        updateLiveCall({
          activeCallJobId: jobId,
          type: automationType === AutomationTypeEnum.basic ? CallTypeEnum.standard : CallTypeEnum.humanAgent,
          activeClaimId: oaiClaimId,
          claimId: claimId,
          activeCallJbId: jbId,
        }),
      )
      if (
        TakeOverTypeEnum.none !== takeOver.type &&
        activeTalkToPayorRepCall.jobType !== CallTypeToJobTypeEnum.diagnosticHeadset &&
        shouldRedirectIfCallTakenOver
      ) {
        dispatch(updateLiveCall({ shouldRedirectIfCallTakenOver: false }))
        redirectToLiveCalls(oaiClaimId, jobId)
      }
    }
  }, [activeTalkToPayorRepCall])
  return null
}

export { CallCompletionNotifier }
